module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar progress-bar-half-circle"
  }, [(_vm.value > 0) ? _c('div', {
    staticClass: "left back-done"
  }) : _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "back"
  })]), _vm._v(" "), (_vm.value >= 100) ? _c('div', {
    staticClass: "right back-done"
  }) : _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "barOverflow"
  }, [_c('div', {
    ref: "bar",
    staticClass: "bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "progress-bar-value"
  }, [_vm._v(_vm._s(_vm._f("format_performance")(_vm.value)) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-text"
  }, [_vm._v("Performance")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1089fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/progress-bar-half-circle.vue
// module id = 1080
// module chunks = 0